module.exports = __webpack_public_path__ + "static/media/Rectangle 77.bcf0918b.png";